export default __webpack_public_path__ + "b7a28a420c4a58ebc3985776c38e374c.png";